/* @flow */

import React from 'react'
import { omit } from 'lodash'

import type { ExpertOpinion } from '../types'

export default function ExpertOpinionSVGImage(props: {
  expertOpinion: ExpertOpinion,
  sketchRadius: number,
  iconSize: number,
}) {
  const passOnProps = omit(props, ['expertOpinion', 'sketchRadius', 'iconSize'])

  if (props.expertOpinion.icon == null) {
    throw new Error('missing property icon on expertOpinion')
  }

  const iconRadius = props.iconSize / 2

  return (
    <svg
      x={
        props.sketchRadius +
        props.sketchRadius * props.expertOpinion.x -
        iconRadius
      }
      y={
        props.sketchRadius +
        props.sketchRadius * props.expertOpinion.y -
        iconRadius
      }
      width={props.iconSize}
      height={props.iconSize}
    >
      <clipPath id="clipCircle">
        <circle
          id="clipCircle"
          r={iconRadius}
          cx={iconRadius}
          cy={iconRadius}
        />
      </clipPath>
      <image
        preserveAspectRatio="none"
        xlinkHref={props.expertOpinion.icon.url}
        width={props.iconSize}
        height={props.iconSize}
        clipPath="url(#clipCircle)"
        {...passOnProps}
      />
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/components/ExpertOpinionSVGImage.js